import controller from './alerts-actions-nav.controller';

const template = require('./alerts-actions-nav.html');

export default {
    bindings: {
        alertsActions: '<',
        onPushCurrent: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-nav/alerts-actions-nav.component.js